<div class="a-fx a-fx-start-center a-fx-gap-8">
    <nz-switch
        class="a-fx"
        nzSize="small"
        [ngModel]="showResolved$ | async"
        (ngModelChange)="updateResolvedFilter($event)"
        #toggle
    ></nz-switch>

    <span class="a-cursor-pointer" (click)="updateResolvedFilter(!toggle.isChecked)">
        {{ 'alert-center.drawer.show-resolved' | translate }}
    </span>
</div>
